import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const getUsers = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IWithDrawUsers } = await request.get(
        `/api/v1/moneypools/${ctx.queryKey[1]}/poolships/${
            ctx.queryKey[2] && '?q=' + ctx.queryKey[2]
        }`
    )
    return data
}

export const getUsersCards = async (ctx: QueryFunctionContext) => {
    if (ctx.queryKey[1]) {
        const { data }: { data: IGetCards } = await request.post(
            `/api/v1/payment/init/?os_type=android&app_version=1.892.9`,
            [
                {
                    id: ctx.queryKey[1],
                    type: 'psp',
                    amount: 0,
                    cashin_type: 'cns',
                    paid_obj_id: 0,
                },
            ]
        )
        return data
    }
}
export const setCashout = async (payload: IGetCardsPayloadFinal) => {
    const { data }: { data: IGetCashout } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/moneypool-cashouts/`,
        {
            poolship: payload.poolship,
            amount: payload.amount,
            type: 'ctc',
            tag: payload.tag,
            reason: payload.reason,
            // linking is what makes the manager's ordinary «برداشت وجه» count
            // against an open درخواست برداشت; omitted, this is an unrelated
            // cash-out exactly as before
            ...(payload.withdrawal_request
                ? { withdrawal_request: payload.withdrawal_request }
                : {}),
        }
    )
    return data
}
export const setCashoutFinal = async (payload: IGetCardsPayloadFinal) => {
    const { data } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/moneypool-cashouts/`,
        {
            poolship: payload.poolship,
            amount: payload.amount,
            type: 'ctc',
            tag: payload.tag,
            reason: payload.reason,
            ...(payload.withdrawal_request
                ? { withdrawal_request: payload.withdrawal_request }
                : {}),
            transaction: {
                bank_account: payload.bank_account,
                ctx_id: payload.ctx_id,
                ctx_type: 'mnp',
                destination: 'mba',
                is_group_pay: false,
                payer_name: '',
                receiver: payload.receiver,
                receiver_name: '',
                source: 'hbb',
                state: '',
                state_time: '',
                transaction_code: '',
            },
        }
    )
    return data
}
